export const PANEL_TOOLTIP_MIN_WIDTH = 200;
export const PANEL_TOOLTIP_MAX_WIDTH = 650;
export const PANEL_TOOLTIP_MAX_HEIGHT = 500;
export const PANEL_TOOLTIP_HORIZONTAL_SPACING = 2;
export const PANEL_TOOLTIP_PADDING = 8;
export const PANEL_TOOLTIP_ADJUST_Y_POS_MULTIPLIER = 0.75;
export const PIN_TOOLTIP_HELP_TEXT = 'Click chart to pin';
export const UNPIN_TOOLTIP_HELP_TEXT = 'Unpin';
/**
 * Check whether mouse event has zrender custom properties.
 * zrX and zrY are helpful for handling browser inconsistencies.
 */ export const isZRMouseEvent = (event)=>{
    return 'zrX' in event && 'zrY' in event;
};
export const DEFAULT_PANEL_TOOLTIP_CONFIG = {
    enabled: true,
    enablePinning: true
};
export const PANEL_TOOLTIP_CONFIG_PINNING_DISABLED = {
    enabled: true,
    enablePinning: false
};
/** Highest throttle time that does not cause noticeable lag when moving cursor */ export const PANEL_TOOLTIP_THROTTLE_MS = 150;

//# sourceMappingURL=model.js.map